(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[297],{

/***/ 6175:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/KDTReviewItem",
      function () {
        return __webpack_require__(72936);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var KDTReviewItem = function(param) {
    var title = param.title, review = param.review, student = param.student, schoolName = param.schoolName, onClick = param.onClick, isAnonymous = param.isAnonymous;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onClick,
        className: "box-border flex h-[360px] flex-col overflow-hidden rounded-2xl border border-gray-300 bg-white px-4 py-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "border-b border-gray-300",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[23px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/img/double_quotation_img.png",
                            alt: "쌍따옴표",
                            className: "w-full"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-3 mt-2 text-sm font-semibold text-blue-800 md:text-base",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mb-5 mt-3 line-clamp-[8] text-ellipsis whitespace-pre-line break-words text-sm",
                children: review
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-auto text-xs text-gray-500 md:text-sm",
                children: [
                    schoolName,
                    " - ",
                    isAnonymous ? "익명" : "".concat(student, "님")
                ]
            })
        ]
    }, title);
};
/* harmony default export */ __webpack_exports__["default"] = (KDTReviewItem);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(6175); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);